import React from 'react';
import { Route } from 'react-router';
import cn from 'classnames';

import PinLock from 'components/core/PinLock.component';
import SidebarMenu from 'components/menu/SidebarMenu.component';
import StylistsPermissionsPage from 'components/settings/StylistsPermissions.component';
import CreateWaitlist from 'components/waitlist/CreateWaitlist.component';
import LINK from 'constants/link.const';
import useIsFromMobileApp from 'hooks/useIsFromMobileApp.hook';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';

import TopNav from 'common/TopNav.component';
import BillingLayout from 'settings/billing/BillingLayout';
import SetUpView from 'settings/noshowvisibility/SetUpView.component';
import RolesLayout from 'settings/roles/RolesLayout';
import SalonOverview from 'settings/salon/SalonOverview.component';
import SettingSummary from 'settings/salon/SettingSummary.component';
import ServicesLayout from 'settings/services/ServicesLayout';
import SettingsMenu from 'settings/SettingsMenu.component';
import StylistsLayout from 'settings/stylists/StylistsLayout';
import Policy from 'settings/user/Policy.component';
import UserSettingNetwork from 'settings/user/UserNetwork.component';
import UserSettings from 'settings/user/UserSettings';

import CN from './PageContent.module.scss';

const PageContent = () => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();
  const isFromMobile = useIsFromMobileApp();

  return (
    <div
      data-bem="PageContent"
      className={cn({
        [CN.component]: true,
        [CN.darkMode]: isDarkMode,
      })}
    >
      {!isFromMobile && (
        <TopNav title={t('staffAndBusiness.title')}>
          <SidebarMenu />
        </TopNav>
      )}
      <div
        data-bem="PageContent__layout"
        className={cn({
          [CN.layout]: true,
          [CN.layoutMobileHiddenNav]: isFromMobile,
        })}
      >
        {!isFromMobile && (
          <div data-bem="PageContent__menuContainer" className={CN.menuContainer}>
            <SettingsMenu />
          </div>
        )}
        <div data-bem="PageContent__pageContainer" className={CN.pageContainer}>
          <PinLock hasSwitch>
            <Route exact path="/salon/:id/settings" />
            <Route path={LINK.settingsSalon} component={SettingSummary} />
            <Route path={LINK.salonHours} component={SalonOverview} />
            <Route path={LINK.settingWaitlist} component={CreateWaitlist} />
            <Route path={LINK.settingsUser} component={UserSettings} />
            <Route path={LINK.settingsUserNetwork} component={UserSettingNetwork} />
            <Route path={LINK.settingStylist} component={StylistsLayout} />
            <Route path={LINK.permissions} component={StylistsPermissionsPage} />
            <Route path={LINK.settingRoles} component={RolesLayout} />
            <Route path={LINK.billing} component={BillingLayout} />
            <Route path={LINK.settingsCalendar} component={SetUpView} />
            <Route path={LINK.settingsPolicy} component={Policy} />
          </PinLock>

          {/* The ServicesLayout component has re-rendering issues if put under PinLock directly or indirectly  */}
          <Route path="/salon/:id/settings/services" component={ServicesLayout} />
        </div>
      </div>
    </div>
  );
};

export default PageContent;
